<template>
  <el-dialog
    v-if="showDialogVisible"
    width="800px"
    :title="dialogTitle"
    :visible.sync="showDialogVisible"
    destroy-on-close
    custom-class="revenue-code-number"
    :before-close="cancel"
  >
    <div style="color: #ff142f; padding-bottom: 20px">
      注：主营区域可设置多条，区域可选择至区域或省或市
    </div>
    <div>
      <el-cascader-panel
        title="选择主营区域"
        v-model="addressList"
        :options="deliveryAreaOptions"
        :props="addressProps"
      />
      <!-- <p>{{ addressList }}</p>
      <p>{{ getReqData() }}</p> -->
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="default-mini" @click="cancel">
        <!-- 取 消 -->
        取 消
      </el-button>
      <el-button size="mini" type="primary-font-mini" @click="handleTrue">
        <!-- 确 定 -->
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { qryAllProForTwo } from "@/api/lessor-open-shop.js";

export default {
  name: "concAddress",
  props: {
    dialogTitle: {
      type: String,
      default: "选择主营区域"
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      addressList: [],
      addressProps: {
        checkStrictly: false, //不互相关联
        emitPath: true, // false只返回该节点的值
        multiple: true,
        lazy: false
      },
      showDialogVisible: false,
      deliveryAreaOptions: []
    };
  },
  created() {},
  methods: {
    init(list) {
      this.addressList = [];
      if (list && list.length > 0) {
        this.addressList = list.map(el => {
          const item = [];
          if (el.areaName && el.areaId) {
            item.push(el.areaName + "-" + el.areaId);
          }
          if (el.provinceName && el.provinceId) {
            item.push(el.provinceName + "-" + el.provinceId);
          }
          if (el.cityName && el.cityId) {
            item.push(el.cityName + "-" + el.cityId);
          }
          return item;
        });
      }
      this.getQryAreaAddress();
      this.showDialogVisible = true;
    },
    cancel() {
      this.showDialogVisible = false;
    },

    getReqData() {
      const res = this.addressList.map(el => {
        const area = el[0];
        const province = el[1] || "";
        const city = el[2] || "";
        return {
          deliveryAreaName: area ? area.split("-")[0] : "",
          deliveryAreaCode: area ? area.split("-")[1] : "",
          provinceName: province ? province.split("-")[0] : "",
          province: province ? province.split("-")[1] : "",
          cityName: city ? city.split("-")[0] : "",
          city: city ? city.split("-")[1] : ""
        };
      });
      return res;
    },
    // 查询区域
    getQryAreaAddress() {
      qryAllProForTwo({}).then(res => {
        if (res.data.code == 0) {
          // 承运商类型选择“国际货运代理”时，主营区域展示海外的区域选择数据；其它类型承运商，均不展示海外。
          console.log(this.detail, "this.detail");
          let flag =
            this.detail.shopSupplierSubcategoryBOList.filter(
              item => item.subcategoryCode == 4
            ).length > 0;
          console.log(flag, "flag");
          let list = res.data.data.filter(v => {
              if (flag) {
                return v
              } else {
                return !["980000"].includes(v.addressCode);
              }
          });
          this.handelTree(list); // 处理树结构数据
          this.deliveryAreaOptions = list;
        }
      });
    },
    handelTree(list) {
      list.forEach(el => {
        el.value = el.addressName + "-" + el.addressCode;
        el.label = el.addressName;
        el.leaf = el.grade == 2;
        if (el.children && el.children.length > 0) {
          this.handelTree(el.children);
        } else {
          el.children = null;
        }
      });
    },

    // 确定
    handleTrue() {
      this.$emit("selectMainArea", this.getReqData());
      this.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-cascader-menu {
  width: 255px;
}
/deep/ .el-cascader-menu__wrap {
  height: 470px;
}
</style>
